<template>
    <div>
        <div class='d-flex justify-content-between align-items-center' :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <Icon v-if="isMobile" name="arrow-left" class="pointer" v-on:click='this.close'/>
            <h4 class="text-black fsp20 neue mb-0 lh28" :class="{ 'mr24 flex-grow-1 text-center': isMobile }">
                {{ this.content.title ? isMobile ? this.content.mobileTitle : this.content.title : this.$t('components.service.modal.Confirm.1') }}
            </h4>
            <Icon v-if="!isMobile" name='close' class="pointer" v-on:click='this.close'/>
        </div>
        <div class='bg-white rounded12' :class="{'p24': !isMobile}">
            <div class='p-0 neue-roman fsp16'>{{this.content.text}}</div>
            <!-- P2P удаление объявления -->
            <div v-if="this.content.timeout && this.content.code" class='mt12 border-t d-flex flex-column gap-2' :class="{ 'pt12 mt12': !isMobile, 'pt16 mt16': isMobile }">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="primary-grey neue-roman fsp14 lh20">{{ this.$t('components.service.modal.p2p.AdInfo.1') }}</div> 
                    <div class="fsp14 lh20">#{{ this.content.code }}</div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="primary-grey neue-roman fsp14 lh20">{{ this.$t('components.service.modal.p2p.AdInfo.8') }}</div> 
                    <div class="fsp14 lh20 d-flex align-items-center">
                        <Icon name="clock" :active="false" class="c16"/> 
                        <span class="ml4">{{ this.content.timeout }} {{ this.$t('components.service.modal.p2p.AdInfo.9') }}</span>
                    </div>
                </div>
            </div>
            <div v-else class='mt12 neue-roman'>{{ this.$t('components.service.modal.Confirm.4') }}</div>
            <div class='d-flex mt24' :class="{ 'position-fixed px24 py16 start-0 bottom-0 bg-white w-100 border-t': isMobile }">
                <Button 
                    :name="this.content.btnConfirm ? this.content.btnConfirm : $t('components.service.modal.Confirm.3')" 
                    type='btn-outline-red' 
                    id="btn_confirm_true"
                    class="mr16 h48 equal-width"
                    v-on:click='this.submit'
                />
                <Button 
                    :name="this.content.btnCancel ? this.content.btnCancel : $t('components.service.modal.Confirm.2')" 
                    class='h48 equal-width' 
                    type='btn-outline-grey' 
                    id="btn_confirm_cancel"
                    v-on:click='() => {
                        if (this.$store.state.modal.content.onCancel) {
                            this.$store.state.modal.content.onCancel();
                        }
                        this.close();
                    }'
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import Input from '@/components/service/Input';
import Icon from '@/components/icons/Icon';

export default {
    components: {
        Button,
        Input,
        Icon
    },
    props: {
        close: [Function], 
    },
    data () {
        return {
            content: this.$store.state.modal.content,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
    },
    methods: {
        submit() {
            let callback = this.content.callback;
            this.$store.commit('MODAL', {
                        action: false,
                        type: false,
                        content: false
                    })
            this.$store.commit('DARK_WRAPPER', false);
            callback();
        }
    },
}
</script>